module.exports = __webpack_public_path__ + "media/images/shared/about_live/talkport/8-8d1c1a96966acb28007d2c8d82f2153e.png";